import { Navigate, Outlet } from "react-router-dom";
import { StoreExecutorProvider } from "../Contexts/Store/StoreExecutor";
import { UserProvider } from "../Contexts/user/UserContext";
import { WebSocketProvider } from "../Contexts/WebSocketContext";
const ProtectedRoute = () => {
  const isAuthenticated = () => {
    const token = localStorage.getItem("viw_token");
    if (token && token !== "null") return true;
    else return false;
  };

  if (!isAuthenticated()) {
    return <Navigate to="/authorize/auth/" replace />;
  }

  return (
    <UserProvider>
      <WebSocketProvider>
        <StoreExecutorProvider>
          <Outlet />
        </StoreExecutorProvider>
      </WebSocketProvider>
    </UserProvider>
  );
};

export default ProtectedRoute;
